import PropTypes from 'prop-types';
import { useState } from 'react';
import clsx from 'clsx';
import { useAnalytics } from 'use-analytics';
import DeckPlan from './DeckPlan';

const DeckPlans = ({ deckPlans }) => {
  const [selectedDeck, setSelectedDeck] = useState(deckPlans ? deckPlans[0] : null);
  const { track } = useAnalytics();

  const handleShipDeckClick = (deck) => {
    setSelectedDeck(deck);
    track('deckPlans.handleShipDeckClick', {
      name: (deck || {}).shipDeckName, // null handling just in case
    });
  };

  return (
    <div className="grid grid-cols-4">
      <div className="bg-body-0 p-0 md:p-10">
        {deckPlans && deckPlans.map((p) => (
          <div
            key={p.shipDeckName}
            onClick={() => { handleShipDeckClick(p); }}
            onKeyDown={() => { handleShipDeckClick(p); }}
            role="button"
            tabIndex="-1"
            className={clsx('p-1 lg:p-2 block cursor-pointer border border-theme border-opacity-0 focus:outline-none text-sm lg:text-base',
              selectedDeck.shipDeckName === p.shipDeckName && 'bg-theme bg-opacity-10 text-theme rounded-lg border-opacity-10')}
          >
            {p.shipDeckName}
          </div>
        ))}
      </div>
      <div className="col-span-3 text-center">
        <DeckPlan deckPlan={selectedDeck} />
      </div>
    </div>
  );
};

DeckPlans.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  deckPlans: PropTypes.array,
};

DeckPlans.defaultProps = {
  deckPlans: undefined,
};

export default DeckPlans;
